module.exports = __webpack_public_path__ + "img/purple.e029a904.svg";